var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 18.573c-1.736 0-3.368-0.676-4.596-1.903-1.227-1.228-1.904-2.86-1.904-4.597s0.677-3.369 1.904-4.597c0.391-0.391 1.023-0.391 1.414 0s0.391 1.023 0 1.414c-0.85 0.851-1.318 1.981-1.318 3.183s0.468 2.333 1.318 3.183c0.85 0.85 1.979 1.317 3.182 1.317s2.332-0.468 3.182-1.317c0.851-0.85 1.318-1.98 1.318-3.183s-0.468-2.333-1.318-3.183c-0.391-0.391-0.391-1.023 0-1.414s1.023-0.391 1.414 0c1.227 1.229 1.904 2.861 1.904 4.597s-0.677 3.369-1.904 4.597c-1.228 1.227-2.86 1.903-4.596 1.903z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 11c-0.553 0-1-0.448-1-1v-5c0-0.552 0.447-1 1-1s1 0.448 1 1v5c0 0.552-0.447 1-1 1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPower);
export default __webpack_public_path__ + "static/media/power.07735cc8.svg";
export { ForwardRef as ReactComponent };